import React from 'react';
import {Heading, Button} from '../elements';

export const BannerComponent = (props) => {
  const {content, options} = props;

  const background = {
    backgroundImage: `url( ${ content.backgroundImage} )`,
    backgroundRepeat: `no-repeat`,
    backgroundColor: `${ content.backgroundColor }`
  };
  const textColor = {
    color: content.textColor && `${ content.textColor }`
  };

  return (
      <section className="kiwi-banner" style={ background }>
          <div className="mask">
              <div className="container">
                  <div className="row">
                      <div className="col-xs-12">

                              { (options.layout !== 'Image only') && <div className="banner-content  text-center">
                                  <div className="banner-content__heading">
                                      { content.heading &&
                                      <Heading content={ content.heading } size="h1" style={ textColor }/> }
                                  </div>
                                  <div className="banner-content__sub-heading">
                                      { content.subHeading &&
                                      <Heading content={ content.subHeading } size="h2" style={ textColor }/> }
                                  </div>
                                  { options.hasButton &&
                                  <Button label={content.button.label} link={content.button.link}
                                          color={content.button.color} textColor={content.button.textColor} /> }
                              </div> }

                      </div>
                  </div>
              </div>
          </div>
      </section>
  )
};



// WEBPACK FOOTER //
// src/client/components/common/CMS/components/BannerComponent.js